var signoutTimer;
var warningInterval;

function reInitSessionExtension(){
    if (!InFlight.User.isLoggedIn()) {
        return;
    }

    var myconfig = {
        targetUrl: InFlight.User.psBaseUrl() + '/?cmd=resettimeout',
        targetVerb: 'GET',
        followProposedTemplate: false,
        callback: function (data) {
        }
      };

    var InFlightDC = new InFlightDCType(false);
    InFlightDC.init(myconfig);
    setupSessionExtension();
}

function setupSessionExtension() {
    if (!InFlight.User.isLoggedIn()) {
        return;
    }

    clearInterval(warningInterval);
    clearTimeout(signoutTimer);

    if (window.location.href.indexOf('event-bid-comments.aspx') !== -1
        || window.location.href.indexOf('event-bid-line-bid.aspx') !== -1
        || window.location.href.indexOf('event-bid.aspx') !== -1) {
        warningInterval = extendPSSession(4 * 60); // 4 hours in minutes
    } else {
        warningInterval = extendPSSession();
    }
}

function extendPSSession(minutes) {
    minutes = minutes || InFlight.NLX.Cfg.Customer.timeoutInMinutes;

    var numberOfRequests = (minutes / 15) - 1; //Calculate how many 15 minutes intervals needed to complete the hours
    var fifteenMinsInMS = 15 * 60 * 1000; //15 mins * 60 s * 1000 ms

    var extensionInterval = setInterval(function () {
        var myconfig = {
            targetUrl: InFlight.User.psBaseUrl() + '/?cmd=resettimeout',
            targetVerb: 'GET',
            followProposedTemplate: false,
            callback: function (data) {
            }
          };

        var InFlightDC = new InFlightDCType(false);
        InFlightDC.init(myconfig);
        numberOfRequests--;

        if (numberOfRequests === 0) {
            clearInterval(extensionInterval);

            $('#timeoutWarningModal').modal('show');

            // Signout timer will run to completion, unless user clicks Yes on timeout warning modal,
            // in which case setupSessionExtension() will clear signoutTimer
            signoutTimer = setTimeout(function () {
                localStorage.setItem('loggedOutSessionExpired', 'true');
                $('#timeoutWarningModal').modal('hide');
                InFlight.User.doLogout();
            }, fifteenMinsInMS);
        }

    }, fifteenMinsInMS);

    return extensionInterval;
}

setupSessionExtension();